import { render, staticRenderFns } from "./AxFilesystemViewerHeader.vue?vue&type=template&id=2059f356&scoped=true&"
import script from "./AxFilesystemViewerHeader.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemViewerHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemViewerHeader.vue?vue&type=style&index=0&id=2059f356&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2059f356",
  null
  
)

export default component.exports